import gql from 'graphql-tag';

export const EMPLOYEES_QUERY = {
  es: gql`
    query EmployeesCollection {
      employees(sort: "published_at:asc") {
        id
        name
        position: position_es
        photo {
          url
          alternativeText
        }
      }
    }
  `,
  en: gql`
    query EmployeesCollection {
      employees(sort: "published_at:asc") {
        id
        name
        position: position_en
        photo {
          url
          alternativeText
        }
      }
    }
  `
};
